(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('season-review-carousel')) {
  customElements.define('season-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.season-reviews__track');
      this.slides = [...this.querySelectorAll('.season-reviews__slide')];
      this.controls = this.querySelector('.season-reviews__controls');
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-more-reviews]')?.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        clearTimeout(this.reviewWait);
        const deadline = Date.now() + 10000;
        const scrollToReviews = () => {
          const target = document.getElementById('fulfilled-reviews-all') || document.getElementById('klaviyo-product-reviews-wrapper');
          if (!target) {
            if (Date.now() < deadline) this.reviewWait = setTimeout(scrollToReviews, 200);
            return;
          }
          target.style.scrollMarginTop = '100px';
          target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
          history.replaceState(null, '', '#' + target.id);
        };
        scrollToReviews();
      }, options);
      if (!this.controls) return;
      this.index = 0;
      this.controls.hidden = false;
      this.go = index => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-review-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.querySelector('[data-review-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
        }, 100);
      }, {...options, passive:true});
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('.season-reviews__slide'));
        if (index >= 0) this.go(index);
      }, options);
      this.resize = new ResizeObserver(() => this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:'instant'}));
      this.resize.observe(this.track);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resize?.disconnect(); clearTimeout(this.timer); clearTimeout(this.reviewWait);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
